import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import NewsHero from "./components/NewsHero";
import NewsGrid from "./components/NewsGrid";
import NewsNewsletter from "./components/NewsNewsletter";
import { useState } from "react";
import QuoteModal from "../home/components/QuoteModal";

export default function NewsPage() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar onBookNow={() => setQuoteOpen(true)} />
      <main className="flex-1">
        <NewsHero />
        <NewsGrid />
        <NewsNewsletter />
      </main>
      <Footer />
      {quoteOpen && <QuoteModal onClose={() => setQuoteOpen(false)} />}
    </div>
  );
}
